import {handleError} from "../../../helpers/handleError";
import eventBus from "../../../event-bus/eventBus";
import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";

const resetPassword = {
    namespaced: true,
    state: {
        resetIsFetching: false,
        isUserResetPassword: false,
        modalData: {}
    },
    mutations: {
        RESET_SUCCESS(state, response) {
            localStorage.setItem("messageSave", response.data.message);
            localStorage.setItem("textSave", response.data.data.textInfo);
            window.location.href = "/user/login";
        },
        RESET_FAILURE(state, error) {
            state.modalData.headInfoResetPassword = error.response.data.message;
            state.modalData.textInfoResetPassword = handleError(error) !== "" ? handleError(error) : error.response.data.data.textInfo;
            state.modalData.typeInfoResetPassword = "red";
            state.isUserResetPassword = true;
            eventBus.$emit("resetPasswordFailure", error.response.data.errors);
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isUserResetPassword = value;
        }
    },
    actions: {
        resetPassword: function({ dispatch, state }, payload) {
            dispatch("requestReset");
            var promise = sendRequest("post", config.baseURLApi+'/users/forgot-password', {}, payload.creds, false);
            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("successReset", $result[1]);
                } else {
                    dispatch("failureReset", $result[1]);
                }
                state.resetIsFetching = false;
            });
        },
        requestReset: function({ state }) {
           state.resetIsFetching = true;
        },
        successReset: function({ commit }, response) {
            commit("RESET_SUCCESS", response);
        },
        failureReset: function({ commit }, error) {
            commit("RESET_FAILURE", error);
        },
        updateVisibleModal: function(context, value) {
            context.commit("UPDATE_VISIBLE_MODAL", value);
        }
    }
}

export default resetPassword;